import { useState } from "react";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import { usePortfolioWidgetData } from "../widgetHooks";
import PortfolioWidgetListDialog from "./PortfolioWidgetListDialog";
import TabularWidgetPreviewCard from "./TabularWidgetPreviewCard";

interface Props {
  widgetSettings: PortalWidget;
}

const PortfolioWidgetPreviewCard = ({ widgetSettings }: Props) => {
  const [showFullWidget, setShowFullWidget] = useState(false);

  const { report, fetchError, noDataText } = usePortfolioWidgetData(widgetSettings, {
    rowsLimit: 1,
  });

  return (
    <>
      <TabularWidgetPreviewCard
        widgetSettings={widgetSettings}
        report={report}
        columnsLimit={5}
        noDataText={noDataText}
        fetchError={fetchError}
        onViewAllClick={() => setShowFullWidget(true)}
      />

      {showFullWidget && (
        <PortfolioWidgetListDialog widgetSettings={widgetSettings} onClose={() => setShowFullWidget(false)} />
      )}
    </>
  );
};

export default PortfolioWidgetPreviewCard;
